export default __webpack_public_path__ + "static/media/dancingbear.a597d301.gif";